import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { FAVORITES, FOLLOWING } from './favNotificationsConstants';
import style from './FavNotificationsTile-style.scss';

const messages = {
    [FAVORITES]: {
        header: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileEmpty.favorites_header'
                defaultMessage='You have 0 likes'
            />
        ),
        text: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileEmpty.favorites_text'
                defaultMessage={
                    'Save items you love and get updates. Click on the heart next to each item to save.'
                }
            />
        )
    },
    [FOLLOWING]: {
        header: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileEmpty.following_header'
                defaultMessage='You have 0 follows'
            />
        ),
        text: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileEmpty.following_text'
                defaultMessage='Follow categories, dealers and designers to see new additions.'
            />
        )
    }
};

const FavNotificationsTileEmpty = ({ type }) => {
    const staticContent = messages[type];

    return (
        <div className={style.container}>
            <div className={style.headerText}>{staticContent.header}</div>
            <div className={style.emptyText}>{staticContent.text}</div>
        </div>
    );
};

FavNotificationsTileEmpty.propTypes = {
    type: PropTypes.string.isRequired
};

export default FavNotificationsTileEmpty;



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FavNotificationsTileEmpty.jsx